module.exports = __webpack_public_path__ + "static/media/YF74_01.5b4a04a9.jpg";